module.exports = __webpack_public_path__ + "img/event_3_cover.5a0fb93e.jpg";